<template>
  <div>
    <section class="section bg-transparent novi-background"
             data-preset='{"title":"Progress Linear","category":"infographics, sample","reload":true,"id":"progress-linear"}'>
      <label v-if="fileInfos.length === 0 && docrule === undefined" class="btn btn-outline btn-sm btn-primary w-100">
        <span class="col">{{ hasDocRules ? 'Select Other' : 'Select' }} Documents</span><span class="btn-icon mdi-file icon-md novi-icon"></span>
        <input type="file" ref="file" @change="selectFiles" multiple/>
      </label>
      <label v-if="fileInfos.length === 0 && docrule !== undefined" class="btn btn-outline btn-sm btn-warning w-100">
        <span class="col">Upload {{ docrule.title }}</span><span class="btn-icon mdi-upload icon-md novi-icon"></span>
        <input type="file" ref="file" @change="selectFiles"/>
      </label>

      <section v-if="fileInfos.length > 0" class="section  novi-background">
        <div class="row">
          <div class="col">
            <!-- Offer box light-->
            <div class="offer-box offer-box-light">
              <ul class="offer-box-list">
                <li v-for="doc in fileInfos" v-bind:key="doc.file.name">
                  <div class="row">
                    <div v-if="doc.progress === 0" class="icon icon-sm icon-secondary mdi-upload novi-icon"></div>
                    <div v-else-if="doc.progress === 100"
                         class="icon icon-sm icon-success int-check-circle-filled novi-icon"></div>
                    <div v-else-if="doc.progress === -1" class="icon icon-sm icon-danger fa-ban novi-icon"></div>
                    <div v-else class="icon icon-sm icon-danger novi-icon">{{ doc.progress }}%</div>
                    <div class="col">
                      <span class="offer-box-list-text">{{ doc.file.name }}</span>
                      <br>
                      <div class="form-group">
                        <!--                          <label for="inputSize1">Input small</label>-->
                        <div class="position-relative">
                          <input v-model="doc.title" class="form-control form-control-sm" id="inputSize1" type="text"
                                 placeholder="Document Title">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="offer-box-divider"></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <button v-if="fileInfos.length > 0" @click="upload(0)" class="btn btn-outline btn-sm btn-warning w-100">
        <span class="btn-icon mdi-upload icon-md novi-icon"></span>Upload Documents
      </button>
      <button v-if="fileInfos.length > 0" @click="clear()" class="btn btn-outline btn-sm btn-danger w-100">
        <span class="btn-icon fa-ban icon-md novi-icon pr-1"></span> Cancel
      </button>
    </section>

    <div id="myModal" class="modal" :class="{'show-modal' : isShowTitleModal}">

      <!-- Modal content -->
      <div class="modal-content">
        <span class="close">&times;</span>
        <p>Some text in the Modal..</p>
      </div>

    </div>
  </div>
</template>

<script>

import FileUploadService from "@/mixins/FileUploadService";

export default {
  name: "FileUpload",
  mixins: [
    FileUploadService
  ],
  data() {
    return {
      currentFile: undefined,
      uploading: false,
      isShowTitleModal: false,
      fileInfos: []
    };
  },
  props: {
    doctype: {
      type: Object,
      required: true
    },
    docrule: {
      type: Object,
      required: false
    }
  },
  computed: {
    hasDocRules() {
      return this.doctype.rules && this.doctype.rules.length > 0;
    }
  },
  methods: {
    selectFiles() {
      // this.selectedFiles = this.$refs.file.files;
      console.log(this.$refs.file.files);

      if (this.$refs.file.files && this.$refs.file.files.length > 0) {
        // (this.$refs.file.files || []).forEach(f => {
        for (let f of this.$refs.file.files) {
          this.fileInfos.push(
              {
                title: this.docrule ? this.docrule.title : null,
                ref: this.docrule ? this.docrule.id : null,
                file: f,
                progress: 0
              });
        }
      }
      /**
       * if it is doc rule auto upload the document
       */
      if (this.docrule) {
        this.upload(0);
        // } else {
        //   this.isShowTitleModal = true;
      }
    },
    upload(index) {
      this.uploading = true;
      this.currentFile = this.fileInfos[index];
      this.currentFile.progress = 0;
      this.uploadFile(this.doctype.code, this.currentFile, event => {
        this.currentFile.progress = Math.round((100 * event.loaded) / event.total);
      }).then(response => {
        console.log(response.data);
        this.currentFile.progress = 100;
        this.uploadNext(index);
      }).catch(() => {
        this.currentFile.progress = -1;
        this.uploadNext(index);
      });

      this.selectedFiles = undefined;
    },
    uploadNext(currentIndex) {
      if (currentIndex < this.fileInfos.length - 1) {
        this.upload(currentIndex + 1)
      } else {
        this.uploading = false;

        if (this.fileInfos.filter(o => o.progress !== 100).length === 0) {
          this.fileInfos = [];
          this.$emit('on-upload', 'done');
        }
      }
    },
    clear() {
      this.fileInfos = [];
      this.uploading = false;
      this.$emit('on-upload', 'done');
    },
    showDocTitleModal() {
      // btn.onclick = function() {
      //   modal.style.display = "block";
      // }

// When the user clicks on <span> (x), close the modal
//       span.onclick = function() {
//         modal.style.display = "none";
//       }
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  display: none;
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 8; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.show-modal {
  display: block;
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

/*.close:hover,*/
/*.close:focus {*/
/*  color: #000;*/
/*  text-decoration: none;*/
/*  cursor: pointer;*/
/*}*/
</style>
